import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const updateTask = ({ churchId, taskId, task }) => {
  return axios.put(`/churches/${churchId}/tasks/${taskId}`, task);
};

export const useUpdateTask = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("tasks");
      setNotification({
        type: "success",
        message: "Task updated successfully!"
      });
    },
    ...config,
    mutationFn: updateTask
  });
};
